export default __webpack_public_path__ + "static/media/ic_news_off.828b47bb.svg";